module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-setting"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('setting_title'),
      "url": "/opera/center",
      "replace": "true"
    }
  }), _vm._v(" "), _c('mt-cell', {
    staticClass: "split topcell",
    staticStyle: {
      "margin-top": "0.4rem"
    },
    attrs: {
      "title": _vm.$t('setting_account_security'),
      "to": "/opera/account",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell', {
    staticClass: "topcell",
    attrs: {
      "title": _vm.$t('setting_message_notice'),
      "to": "/opera/messagePush?redirect=/opera/setting",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('settinge_device'),
      "to": "/opera/device",
      "is-link": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mint-cell split"
  }, [_c('div', {
    staticClass: "mint-cell-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-wrapper",
    on: {
      "click": _vm.clearCache
    }
  }, [_c('div', {
    staticClass: "mint-cell-title"
  }, [_c('span', {
    staticClass: "mint-cell-text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('setting_clean_localStorage')) + "\n        ")])]), _vm._v(" "), _c('i', {
    staticClass: "mint-cell-allow-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-right"
  })]), _vm._v(" "), (_vm.perInfo.code == 'ADMIN') ? _c('mt-cell', {
    staticStyle: {
      "margin-top": "0.4rem"
    },
    attrs: {
      "title": _vm.$t('setting_sys_option'),
      "to": "/opera/sysOption/sysOptionList",
      "is-link": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6b0861de","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/setting.vue
// module id = 1800
// module chunks = 107